var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaperPlane = function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "PaperPlane_svg__a",
    d: "M52 72 34.517 55.943 61.033 18.82 23.9 45.336 8 32 72 8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#PaperPlane_svg__a",
    fill: "#3da1db",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74cafc",
    d: "m24 45 37.033-26.18-26.516 37.123L32 68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9e1b",
    d: "m32 68 2.517-12.057L39 60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#74cafc",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "m10 56 6-6m8 20 2-2m-16 2 10-10"
  }))));
};
export default SvgPaperPlane;